import { breakpointsTailwind, useBreakpoints } from '@vueuse/core';

import type { AppBreakpoints } from './types';

export default function useAppBreakpoints(): AppBreakpoints {
  return useBreakpoints(breakpointsTailwind);
}
